import Vue from 'vue';
import VueRouter from 'vue-router';
import {ME_QUERY} from '@graphql';
import apolloClient from './apolloClient';
import store from './store';

Vue.use(VueRouter);
const router = new VueRouter({
  base: '/',
  routes: [
    {
      path: '/',
      redirect: () => {
        return 'login';
      }
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (login.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ './app/page/LoginView.vue'),
      meta: {
        redirectIfLoggedIn: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "Dashboard" */ './app/page/DashboardView.vue'),
      meta: {
        requiresAuth: true,
        accessRight: 'DEVICE_MGMT'
      }
    },
    {
      path: '/farm-automation-devices',
      name: 'farm-automation-devices',
      component: () =>
        import(/* webpackChunkName: "FarmAutomationDeviceDashboard" */ './app/page/FarmAutomationDeviceDashboard.vue'),
      meta: {
        requiresAuth: true,
        accessRight: 'DEVICE_MGMT'
      }
    },
    {
      path: '/add-device',
      name: 'adddevice',
      component: () => import(/* webpackChunkName: "addDevice" */ './app/page/AddDevice.vue'),
      meta: {
        requiresAuth: true,
        accessRight: 'ADD_DEVICE_MGMT'
      }
    },
    {
      path: '/add-farm-automation-device',
      name: 'addfarmautomationdevice',
      component: () =>
        import(/* webpackChunkName: "addFarmAutomationDevice" */ './app/page/AddFarmAutomationDevice.vue'),
      meta: {
        requiresAuth: true,
        accessRight: 'ADD_DEVICE_MGMT'
      }
    },
    {
      path: '/edit-farm-automation-device/:serialNo',
      name: 'editfarmautomationdevice',
      component: () =>
        import(/* webpackChunkName: "editFarmAutomationDevice" */ './app/page/EditFarmAutomationDevice.vue'),
      meta: {
        requiresAuth: true,
        accessRight: 'ADD_DEVICE_MGMT'
      }
    },
    {
      path: '/device/:deviceSerialNo',
      name: 'deviceDetails',
      component: () => import(/* webpackChunkName: "deviceDetails" */ './app/page/DeviceDetails.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/information-management',
      name: 'information-management',
      component: () => import(/* webpackChunkName: "InformationManagmenet" */ './app/page/InformationManagement.vue'),
      meta: {
        requiresAuth: true,
        accessRight: 'MANAGE_DEVICE_360_INFORMATION'
      }
    },
    {
      path: '/information-management/OTA',
      name: 'OTA',
      component: () => import(/* webpackChunkName: "firmwareUpload" */ './app/page/OTA/FirmwareUpload.vue'),
      meta: {
        requiresAuth: true,
        accessRight: 'ADD_DEVICE_MGMT'
      }
    },
    {
      path: '/information-management/OTA/upload',
      name: 'OTA-upload',
      component: () => import(/* webpackChunkName: "OTAUpload" */ './app/page/OTA/OTAUpload.vue'),
      meta: {
        requiresAuth: true,
        accessRight: 'ADD_DEVICE_MGMT'
      }
    },
    {
      path: '/sim-inventory',
      name: 'sim-inventory',
      component: () => import(/* webpackChunkName: "simInventory" */ './app/page/SimInventory.vue'),
      meta: {
        requiresAuth: true,
        accessRight: 'DEVICE_MGMT'
      }
    },
    {
      path: '/device-compare',
      name: 'device-compare',
      component: () => import(/* webpackChunkName: "login" */ './app/page/DeviceCompare.vue'),
      meta: {
        requiresAuth: true,
        accessRight: 'DEVICE_MGMT'
      }
    },
    {
      path: '/device-troubleshooting',
      name: 'device-troubleshooting',
      component: () =>
        import(/* webpackChunkName: "login" */ './app/page/DeviceTroubleshooting/DeviceTroubleshooting.vue'),
      meta: {
        requiresAuth: true,
        accessRight: 'DEVICE_MGMT'
      }
    },
    {
      path: '/add-sim',
      name: 'add-sim',
      component: () => import(/* webpackChunkName: "login" */ './app/page/AddSim.vue'),
      meta: {
        requiresAuth: true,
        accessRight: 'DEVICE_MGMT'
      }
    },
    {
      path: '/no-access',
      name: 'no-access',
      component: () => import(/* webpackChunkName: "login" */ './app/page/NoAccess.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ],
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      next({
        name: 'login',
        params: {nextUrl: to.fullPath}
      });
    } else {
      const token = localStorage.getItem('token');
      const {user} = router.app.$store.getters;
      if (token && !user) {
        apolloClient
          .query({
            query: ME_QUERY
          })
          .then(userResponse => {
            const userObj = userResponse.data.me;
            store.commit('USER_CUSTOMER', {
              user: userObj
            });
            if (to.matched.some(record => record.meta.accessRight)) {
              if (userObj.roles.indexOf(to.meta.accessRight) === -1) {
                next({name: 'no-access'});
              } else {
                next();
              }
            }
            next();
          })
          .catch(() => {
            next({
              name: 'login',
              params: {nextUrl: to.fullPath}
            });
          });
      } else {
        if (to.matched.some(record => record.meta.accessRight)) {
          if (user.roles.indexOf(to.meta.accessRight) === -1) {
            next({name: 'no-access'});
          } else {
            next();
          }
        }
        next();
      }
    }
  } else if (to.matched.some(record => record.meta.redirectIfLoggedIn)) {
    if (localStorage.getItem('token')) {
      next({name: 'dashboard'});
    } else {
      next();
    }
  }
});

export default router;
